// extracted by mini-css-extract-plugin
export default {"root":"_1PIir57oSnknAuX7Ps2e63","active":"_1qc2tVdx7nAiq0y9HffHr","pageContent":"_1dq5h4kJ91TazxqH4LTdkn","footer":"_3X8qxA0JCBIOzdspvNK0CD"};